import { Drawer, Descriptions, Tag } from "antd";

interface RemittanceDrawerProps {
  open: boolean;
  onClose: () => void;
  data: any | null;
}

export const RemittanceDrawer = ({
  open,
  onClose,
  data,
}: RemittanceDrawerProps) => {
  if (!data) return null;

  const payments = data.amount?.split(",").map((a: string) => Number(a));

  return (
    <Drawer
      title="Remittance Details"
      width={520}
      open={open}
      onClose={onClose}
    >
      <Descriptions bordered size="small" column={1}>
        <Descriptions.Item label="Inquiry Number">
          {data.inquiryNumber}
        </Descriptions.Item>

        <Descriptions.Item label="Transfer ID">
          {data.transfer_id}
        </Descriptions.Item>

        <Descriptions.Item label="Status">
          <Tag color="green">{data.status}</Tag>
        </Descriptions.Item>

        <Descriptions.Item label="Customer">
          {data.name}
          <br />
          <span className="text-gray-500">{data.mobile}</span>
        </Descriptions.Item>

        <Descriptions.Item label="Vehicle">
          {data.v_modal}
          <br />
          <Tag color="blue">{data.v_type}</Tag>
        </Descriptions.Item>

        <Descriptions.Item label="Payment Breakdown">
          {payments.map((p: number, i: number) => (
            <div key={i}>
              Payment {i + 1}:{" "}
              <strong>
                {p.toLocaleString("en-LK", {
                  minimumFractionDigits: 2,
                })}
              </strong>
            </div>
          ))}
        </Descriptions.Item>

        <Descriptions.Item label="Total Amount">
          <strong className="text-emerald-600">
            {Number(data.totalamount).toLocaleString("en-LK", {
              minimumFractionDigits: 2,
            })}
          </strong>
        </Descriptions.Item>
      </Descriptions>
    </Drawer>
  );
};
